import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Latest } from 'interfaces/latest';
import { deleteLatest, getLatest } from 'redux/ducks/latest';

// import Typography from '@material-ui/core/Typography';

export interface SimpleDialogProps {
  open: boolean;
  onClose: () => void;
  latest: Latest;
}

export default function ModalDeletelatest(props: SimpleDialogProps) {
  const { onClose, open, latest } = props;

  const dispatch = useDispatch();

  const handleClose = (number: number) => {
    if (number === 1) {
      dispatch(getLatest());
    }
    onClose();
  };

  const submitDelete = async () => {
    dispatch(deleteLatest(latest?.id)).then((result: number) => {
      if (result === 1) {
        handleClose(1);
      } else {
        handleClose(0);
      }
    });
  };

  return (
    <Dialog
      onClose={() => handleClose(0)}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        Delete {latest?.title}?
      </DialogTitle>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button onClick={submitDelete} color="primary">
          {' '}
          Delete{' '}
        </Button>
        <Button onClick={() => handleClose(0)}> Cancel </Button>
      </div>
    </Dialog>
  );
}
